<template>
  <main class="view index">
    <div class="keen-slider" :style="`--height: ${containerHeight}px`">
      <div
        v-for="(item, idx) in slides"
        :key="`home-item-${idx}`"
        :class="`keen-slider__slide number-slide${idx+1}`"
        :style="`min-width:${item.width}px; max-width:${item.width}px;`"
      >
        <img :src="item.image" :alt="item.title" />
        <!--
        <router-link :to="item.url">
          <CTA :to="item.url">{{ item.title }}</CTA>
        </router-link>
        -->
      </div>
    </div>
      <!--
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide" v-for="(item, idx) in computedPreview" :key="`home-item-${idx}`">
            <img :src="item.image" :alt="item.title" />
            <router-link :to="item.url">
              <CTA :to="item.url">{{ item.title }}</CTA>
            </router-link>
          </li>
        </ul>
      </div>
      -->
  </main>
</template>

<script>
  import CTA from '@/components/ui/CTA';
  import 'keen-slider/keen-slider.min.css';
  import KeenSlider from 'keen-slider';

  export default {
    name: 'Index',
    components: {
      CTA,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        loaded: false,
        instance: null,
        slides: [],
        containerHeight: 0,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedProjects() {
        const projects = this.$b.data?.projects || [];
        if (projects.length > 0) {
          const out = [];
          projects.forEach((item) => {
            const featured = item?.featured[0] || {};
            const chosenPath = featured?.full || featured?.path;
            out.push({
              title: item.title,
              short: item.short,
              image: `${this.$b.contentUrl}/${chosenPath}`,
              url: `/projects/${item.slug}/`,
            });
          });
          return out;
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    async mounted() {
      const container = this.$el;
      const targetHeight = container.clientHeight;
      this.containerHeight = targetHeight;
      const projects = this.computedProjects;
      for (let i = 0, n = projects.length; i < n; i += 1) {
        const project = projects[i];
        // eslint-disable-next-line no-await-in-loop
        const img = await this.loadImage(project.image);
        const aspect = img.naturalWidth / img.naturalHeight;
        project.width = targetHeight * aspect;
        project.height = targetHeight;
      }
      this.slides = projects;
      this.$nextTick(() => {
        this.instance = new KeenSlider(
          '.keen-slider',
          {
            loop: true,
            mode: 'snap',
            rtl: false,
            slides: { origin: 'center', perView: 'auto' },
          },
          [
            (slider) => {
              let timeout;
              let mouseOver = false;
              function clearNextTimeout() {
                clearTimeout(timeout);
              }
              function nextTimeout() {
                clearTimeout(timeout);
                if (mouseOver) return;
                timeout = setTimeout(() => {
                  slider.next();
                }, 5000);
              }
              slider.on('created', () => {
                slider.container.addEventListener('mouseover', () => {
                  mouseOver = true;
                  clearNextTimeout();
                });
                slider.container.addEventListener('mouseout', () => {
                  mouseOver = false;
                  nextTimeout();
                });
                nextTimeout();
              });
              slider.on('dragStarted', clearNextTimeout);
              slider.on('animationEnded', nextTimeout);
              slider.on('updated', nextTimeout);
            },
          ],
        );
      });
    },
    // beforeUpdate() {},
    // updated() {},
    beforeDestroy() {
      if (this.instance) {
        this.instance.destroy();
        this.instance = null;
      }
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      loadImage(url) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => { resolve(img); };
          img.onerror = () => { reject(); };
          img.src = url;
        });
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';


.view.index {
  padding: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--height);

  & > .keen-slider {
    width: inherit;
    height: var(--height);

    & > .keen-slider__slide {
      display: flex;
      justify-content: center;
      position: relative;
      cursor: grab;

      & > img {
        position: relative;
        z-index: 2;
        width: auto;
        height: 100%;
        object-fit: contain;
        object-position: 50% 50%;
      }

      & > a {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform-origin: 50% 100%;
        transform: translate(-50%, 100%) scale(0.85, 0.85);
        background-color: rgba(255,255,255, 0.85);
        box-shadow: 0 0 4px rgba(0,0,0,0.2);
        z-index: 3;
        opacity: 0;
        display: block;
        color: black;
        text-decoration: none;
        transition: opacity 0.3s 1s, transform 0.3s 1s;
        padding: 10px 10px 15px 10px;
        border-radius: 8px 8px 0 0;

        & > a {
          padding: 0;
          margin: 0;
        }
      }

      & > img:hover + a, & > a:hover {
        opacity: 1;
        transform: translate(-50%, 0) scale(0.85, 0.85);
      }
    }
  }

  /*
  & > .glide {

    .glide__track {
      .glide__slides {
        .glide__slide {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: auto;
          position: relative;
          overflow: hidden;
          cursor: grab;


        }
      }
    }
  }
  */
}
</style>
